var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.653.333a1.104 1.104 0 0 1 0 1.607L2.86 7.5l5.794 5.56a1.104 1.104 0 0 1 0 1.607 1.22 1.22 0 0 1-1.675 0L.347 8.304a1.104 1.104 0 0 1 0-1.608L6.978.333a1.22 1.22 0 0 1 1.675 0"
})));
export default SvgArrowLeft;